<div
  [ngClass]="analyticsService?.currentTheme === 'material-dark' ? 'dark-theme' : ''"
  class="confirmation-dialog-container p-0"
>
  <p class="quicksand-bold-label main-title text-center">Download PDF</p>

  <mat-dialog-content class="p-0">
    <p class="quicksand-normal-label">
      Do you want to keep the default file name or rename it?
    </p>

    <!-- radio buttons -->
    <nb-radio-group
      [(ngModel)]="isRenameSelected"
      class="m-0 bell-schedule-radio"
    >
      <nb-radio [value]="false" class="quicksand-normal-label m-0"
        >Keep default file name</nb-radio
      >
      <br />
      <nb-radio [value]="true" class="quicksand-normal-label m-0"
        >Rename file name</nb-radio
      >
    </nb-radio-group>

    <!-- file -->
    <div *ngIf="isRenameSelected" class="mt-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label class="quicksand-normal-label">Enter file name:</mat-label>
        <input
          matInput
          [(ngModel)]="fileName"
          [maxlength]="characterLimit"
          required
          class="quicksand-normal-label"
          (input)="onFileNameChange()"
        />
      </mat-form-field>

      <!-- Error messages -->
      <mat-error *ngIf="isLimitReached" class="quicksand-normal-label sub-text">
        File name cannot exceed {{ characterLimit }} characters.
      </mat-error>

      <mat-error
        *ngIf="hasMultipleSpaces"
        class="quicksand-normal-label sub-text"
      >
        Only one space is allowed between words.
      </mat-error>

      <!-- Show file name after rename -->
      <div class="sub-text quicksand-normal-label file-name my-3 text-break">
        <strong>Preview: </strong>{{ previewFileName }}
      </div>
    </div>

    <!-- Show default name for clarity -->
    <div
      *ngIf="!isRenameSelected"
      class="mt-2 quicksand-normal-label sub-text file-name my-3"
    >
      <strong>Default file name:</strong> {{ data.defaultFileName }}
    </div>
  </mat-dialog-content>

  <!-- Action buttons -->
  <mat-dialog-actions class="d-flex justify-content-end">
    <button
      nbButton
      (click)="onCancel()"
      class="delete-lesson-plan mr-3 bg-white bg-white-color quicksand-bold-label text-capitalize cancel"
    >
      Cancel
    </button>
    <button
      nbButton
      class="ok quicksand-bold-label text-capitalize"
      (click)="onDownload()"
    >
      Download
    </button>
  </mat-dialog-actions>
</div>
